import React from 'react';
import CRUDList from '../Common/CRUDList';
import { countries } from '../../services/api';

function CountryForm({ formData, setFormData }) {
  return (
    <>
      <div className="form-group">
        <label>Country Name *</label>
        <input
          type="text"
          value={formData.country_name || ''}
          onChange={(e) => setFormData({ ...formData, country_name: e.target.value })}
          required
        />
      </div>

      <div className="form-group">
        <label>ISO Code (2 letters) *</label>
        <input
          type="text"
          value={formData.country_iso_code_2 || ''}
          onChange={(e) => setFormData({ ...formData, country_iso_code_2: e.target.value.toUpperCase() })}
          maxLength={2}
          required
        />
      </div>

      <div className="form-group">
        <label>ISO Code (3 letters) *</label>
        <input
          type="text"
          value={formData.country_iso_code_3 || ''}
          onChange={(e) => setFormData({ ...formData, country_iso_code_3: e.target.value.toUpperCase() })}
          maxLength={3}
          required
        />
      </div>
    </>
  );
}

function CountriesList() {
  return (
    <CRUDList
      title="Countries"
      api={countries}
      columns={['ID', 'Name', 'ISO-2', 'ISO-3']}
      FormComponent={CountryForm}
      defaultFormData={{ country_name: '', country_iso_code_2: '', country_iso_code_3: '' }}
      useOldStyle={true}
      renderRow={(item) => (
        <>
          <td>{item.country_id}</td>
          <td>{item.country_name}</td>
          <td><span className="badge badge-info">{item.country_iso_code_2}</span></td>
          <td><span className="badge badge-info">{item.country_iso_code_3}</span></td>
        </>
      )}
    />
  );
}

export default CountriesList;
